export const MessageTypesEnum = {
	ENGAGEMENT: 'engagement',
	MARKETING: 'marketing',
	TRANSACTIONAL: 'transactional',
} as const;
export const IntegratedChoreographerMessageTypesEnum = [
	MessageTypesEnum.ENGAGEMENT,
	MessageTypesEnum.MARKETING,
] as const;
